/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectUserBannerObject, resetUserBanner } from '../../store/reducers/userBannerSlice'

//css
import styles from './SearchUser.module.scss'

// components
import SearchBar from './components/searchBar'
import UsersList from './components/usersList'
import { Typography } from '@mui/material'
import Alert from '../../components/Alert/Alert'

// actions
import { resetFilteredUsers } from '../../store/reducers/usersSlice'

// hooks
import useUsers from '../../hooks/useUsers'
import Breadcrumbs from '../../components/Breadcrumbs'

import LockClosedIcon from '../../assets/LockClosed.svg'

const SearchUser = () => {
  const [searchText, setSearchText] = useState('')
  const { users, getUsers, areUsersLoading } = useUsers()
  const dispatch = useDispatch()
  const userBannerObject = useSelector(selectUserBannerObject)
  const { t } = useTranslation()

  useEffect(() => {
    if (searchText?.length < 2) {
      dispatch(resetFilteredUsers())
    }
  }, [searchText])

  useEffect(() => {
    return () => {
      dispatch(resetUserBanner())
    }
  }, [])

  const handleAlertClose = () => {
    dispatch(resetUserBanner())
  }

  return (
    <div style={{ height: '90vh' }}>
      <div
        className={styles.stickyHeader}
        style={{ backgroundColor: '#F5F5F5', width: '100vw', padding: '20px' }}
      >
        <Breadcrumbs
          className={styles.stickyHeader}
          value={'Users / View & Edit'}
        />
        
        <h1 className={styles.header}>{t("view-edit-user")}</h1>
        
        <Typography
          variant="h6"
          style={{
              fontSize: '16px',
              fontFamily: 'Johnson Text',
              marginLeft: '80px',
              marginRight: '80px',
              paddingBottom: '8px',
            }}
          >{t("view-edit-user-eyebrow")}
        </Typography>

        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          getUsers={getUsers}
        />
      </div>
      {userBannerObject?.message && (
        <div style={{ paddingTop: '21px', marginLeft: '100px', marginRight: '100px' }}>
          <Alert
            message={userBannerObject?.message}
            alertStyle={"success-one-line"}
            onClose={handleAlertClose}
            showClose
            customStyles={{
              display: 'flex',
              maxWidth: '875px',
              fontSize: '16px',
            }}
          />
        </div>
      )}

      {searchText.length >= 1 && (
        <>
          <div className={styles['user-tips-container']}>
            <div className={styles['user-tips-content']}>
              <span>{t("search-tip-user-detail")}</span>
              <span>|</span>
              <div className={styles['user-tips-locked']}>
                <img
                  src={LockClosedIcon}
                  alt=""
                  style={{ marginBottom: '4px' }}
                />
                <span>{t("search-tip-user-locked")}</span>
              </div>
            </div>
          </div>
          <UsersList users={users} areUsersLoading={areUsersLoading} />
        </>
      )}
    </div>
  )
}

export default SearchUser
